import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/auth/reset-password';
const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;

type url = typeof ENDPOINT_URL_WITH_VERSION;

export type ResetPasswordInput = paths[url]['post']['requestBody']['content']['application/json'];

export const useResetPassword = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);

    const request = async (props: ResetPasswordInput) => {
        setLoading(true);
        setError(null);
        setSuccess(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({
                    ...props,
                    ...getCommonParameters(),
                }),
            });

            if (!response.ok) {
                const json = await response.json();
                const err = new Error(json.message || '') as ApiError;
                err.statusCode = response.status;
                throw err;
            }

            const json = await response.json();
            setSuccess(json.message ?? null);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
            err.message && setError(err.message);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return {
        request,
        loading,
        error,
        success,
        lastResponseTime,
    };
};
